export default function accHierarchy(data) {

  this.popup("accHierarchy", {
    params: data,
    header : this.translate("LBL_ACC_HIERARCHY", "Accounts")
  });
}
